/**
 * @flow
 * @relayHash f82a49a7b6ba3e28af6117311388e2d2
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type CountriesAdminQueryResponse = {|
  +master: ?{| |};
|};
*/


/*
query CountriesAdminQuery {
  master {
    ...Countries_master
  }
}

fragment Countries_master on Master {
  allCountries(first: 50) {
    edges {
      node {
        id
        name
        code
      }
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CountriesAdminQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Master",
        "name": "master",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Countries_master",
            "args": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "CountriesAdminQuery",
  "query": {
    "argumentDefinitions": [],
    "kind": "Root",
    "name": "CountriesAdminQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Master",
        "name": "master",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 50,
                "type": "Int"
              }
            ],
            "concreteType": "CountryConnection",
            "name": "allCountries",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "CountryEdge",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Country",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "code",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "allCountries{\"first\":50}"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "query CountriesAdminQuery {\n  master {\n    ...Countries_master\n  }\n}\n\nfragment Countries_master on Master {\n  allCountries(first: 50) {\n    edges {\n      node {\n        id\n        name\n        code\n      }\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/components/master/__generated__/CountriesAdminQuery.graphql.js